import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  createTuition,
  getTuition,
  updateTuition,
} from '../../api/homepageManagementTrainingAmount.api';
import Button from '../../components/Button';
import ErrorResponse from '../../components/ErrorResponse';
import InputBox from '../../components/homepage/tuition/InputBox';
import MonthInputBox from '../../components/homepage/tuition/MonthInputBox';
import SimpleHeader from '../../components/layout/SimpleHeader';
import Loader from '../../components/Loader';
import SelectCampus from '../../components/SelectCampus';
import useAuth from '../../hooks/useAuth';
import useAxios from '../../hooks/useAxios';
import useNotification from '../../hooks/useNotification';
import { formatAmount } from '../../lib/util';
import { IGetTuition } from '../../models/homepageManagementTrainingAmount.model';
import { RootState } from '../../store/rootReducer';


const Block = styled.div`
  table {
    text-align: center;
  }
`;

const ITuitionInit = {
  day1: '',
  day2: '',
  day3: '',
  day4: '',
  day5: '',
  day6: '',
  day7: '',
  month1: '',
  month2: '',
  month3: '',
  month4: '',
  month5: '',
  month6: '',
  month7: '',
  month8: '',
  month9: '',
  month10: '',
  month11: '',
  month12: '',
  month13: '',
  month14: '',
  amt1: '',
  amt2: '',
  amt3: '',
  amt4: '',
  etc1: '',
  etc2: '',
  etc3: '',
  etc4: '',
};


const HomepageTuition = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const mdCampus = ['CB00000003', 'CB00000006', 'CB00000009', 'CB00000011', 'CB00000005', 'CB00000012'];
  const { successNotification, infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTuition>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetTuition>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [data, setData] = useState<any>();
  const [mdData, setMdData] = useState<any>();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isMdDisabled, setIsMdDisabled] = useState(true);
  const [isEduStepCode, setIsEduStepCode] = useState('EM');

  useEffect(() => {
    if (currentCampus) {
      execute(getTuition(currentCampus, 'EM'));
      execute2(getTuition(currentCampus, 'MD'));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      if(isEduStepCode === 'EM') {
        execute(getTuition(currentCampus, isEduStepCode));
        setIsDisabled(true);
      } else {
        execute2(getTuition(currentCampus, isEduStepCode));
        setIsMdDisabled(true);
      }
      successNotification(t('common.message.save1'));
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (res && !isLoading) {
      if (res.data) setData(_.cloneDeep(res.data));
      else setData({ eduStepCode: 'EM', campusCode: currentCampus, ...ITuitionInit });
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      if (res2.data) setMdData(_.cloneDeep(res2.data));
      else setMdData({ eduStepCode: 'MD', campusCode: currentCampus, ...ITuitionInit });
    }
  }, [res2, isLoading2]);

  const onSetData = (key: string, value: string) => {
    setData({ ...data, [key]: value });
  };

  const onSetMdData = (key: string, value: string) => {
    setMdData({ ...mdData, [key]: value });
  };

  const onSubmit = (eduStepCode: string) => {
    setIsEduStepCode(eduStepCode);
    const req: any = eduStepCode === 'EM' ? { ...data } : { ...mdData };
    delete req.campusEngName;
    delete req.campusKorName;
    delete req.eduStepCode;
    const regex = /\d+/;
    for (const key in req) {
      req[key] = req[key].replace(/,/g, '');
      
      if (!regex.test(req[key])) {
        return infoNotification(t('homepage.tuition.message1'));
      }
    }
    
    if(eduStepCode === 'EM') res?.data ? submitExecute(updateTuition(currentCampus, {...req, eduStepCode})) : submitExecute(createTuition({...req, eduStepCode}));
    else res2?.data ? submitExecute(updateTuition(currentCampus, {...req, eduStepCode})) : submitExecute(createTuition({...req, eduStepCode}));
  };

  return (
    <>
    <SimpleHeader
      iconFile="icon-homepage-big.svg"
      parentMenu={t('common.menu.homepage')}
      currentMenu={t('homepage.tuition.title1')}
      onlyTitle={true}
    />	
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus disabled={!isDisabled} />
            </div>
          </li>
        </ul>
      </div>
    </div>
    
    <Block className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      
      <div className="col-frame">
        <div className="comm-table__area rowType diEdit">
          <table>
            <tbody>
              <tr>
                <th></th>
                <th colSpan={2}>Module 1 (Penta/Hexa/Hepta)</th>
                <th>Module 2 (Octa/Nona)</th>
                <th>Module 3 (Deca/Hendeca)</th>
              </tr>
              <tr>
                <th rowSpan={3}>{t('homepage.tuition.column1')}</th>
                <td>
                  {t('homepage.tuition.column4')}<br />
                  (Penta S / Hexa S)
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
              </tr>
              <tr>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day1}
                    onChange={(e) => onSetData('day1', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day2}
                    onChange={(e) => onSetData('day2', e.target.value)}
                    disabled={isDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day3}
                    onChange={(e) => onSetData('day3', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day4}
                    onChange={(e) => onSetData('day4', e.target.value)}
                    disabled={isDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day5}
                    onChange={(e) => onSetData('day5', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day6}
                    onChange={(e) => onSetData('day6', e.target.value)}
                    disabled={isDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={data?.day7}
                    onChange={(e) => onSetData('day7', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <MonthInputBox
                    value1={data?.month1}
                    onChange1={(e) => onSetData('month1', e.target.value)}
                    value2={data?.month2}
                    onChange2={(e) => onSetData('month2', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={data?.month3}
                    onChange1={(e) => onSetData('month3', e.target.value)}
                    value2={data?.month4}
                    onChange2={(e) => onSetData('month4', e.target.value)}
                    disabled={isDisabled}
                  />
                  <MonthInputBox
                    value1={data?.month5}
                    onChange1={(e) => onSetData('month5', e.target.value)}
                    value2={data?.month6}
                    onChange2={(e) => onSetData('month6', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={data?.month7}
                    onChange1={(e) => onSetData('month7', e.target.value)}
                    value2={data?.month8}
                    onChange2={(e) => onSetData('month8', e.target.value)}
                    disabled={isDisabled}
                  />
                  <MonthInputBox
                    value1={data?.month9}
                    onChange1={(e) => onSetData('month9', e.target.value)}
                    value2={data?.month10}
                    onChange2={(e) => onSetData('month10', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={data?.month11}
                    onChange1={(e) => onSetData('month11', e.target.value)}
                    value2={data?.month12}
                    onChange2={(e) => onSetData('month12', e.target.value)}
                    disabled={isDisabled}
                  />
                  <MonthInputBox
                    value1={data?.month13}
                    onChange1={(e) => onSetData('month13', e.target.value)}
                    value2={data?.month14}
                    onChange2={(e) => onSetData('month14', e.target.value)}
                    disabled={isDisabled}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('homepage.tuition.column5')}</th>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.amt1 || '')}
                    onChange={(e) =>
                      onSetData('amt1', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.amt2 || '')}
                    onChange={(e) =>
                      onSetData('amt2', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.amt3 || '')}
                    onChange={(e) =>
                      onSetData('amt3', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.amt4 || '')}
                    onChange={(e) =>
                      onSetData('amt4', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('homepage.tuition.column6')}</th>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.etc1 || '')}
                    onChange={(e) =>
                      onSetData('etc1', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.etc2 || '')}
                    onChange={(e) =>
                      onSetData('etc2', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.etc3 || '')}
                    onChange={(e) =>
                      onSetData('etc3', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(data?.etc4 || '')}
                    onChange={(e) =>
                      onSetData('etc4', formatAmount(e.target.value))
                    }
                    disabled={isDisabled}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-right mt-3 comm-btn__area right">
          {isDisabled ? (
            <Button
              className="btn-basic pink-line"
              onClick={() => setIsDisabled(false)}
              text={t('common.button.edit')}
              writeAuthYn={writeAuthYn}
            />
          ) : (
            <>
              <Button
                className="btn-basic gray"
                onClick={() => {
                  execute(getTuition(currentCampus, isEduStepCode));
                  setIsDisabled(true);
                }}
                text={t('common.button.cancel')}
              />
              <Button
                className="btn-basic pink"
                onClick={() => onSubmit("EM")}
                text={t('common.button.save')}
                writeAuthYn={writeAuthYn}
              />
            </>
          )}
        </div>

        {/** 중등 */}
        {/*
          mdCampus.includes(currentCampus) &&
        <>*/ }
        <div className="mt-3 comm-table__area rowType diEdit">
          <table>
            <tbody>
              <tr>
                <th></th>
                <th>Module 1 (L1/L2/L3)</th>
                <th>Module 2 (L4/L5)</th>
                <th>Module 3 (L6/L7)</th>
                <th>Special (Z)</th>
              </tr>
              <tr>
                <th rowSpan={3}>{t('homepage.tuition.column1')}</th>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}<br />
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
                <td>
                  {t('homepage.tuition.column3')}<br />
                  {t('homepage.tuition.column4')}
                </td>
              </tr>
              <tr>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day1}
                    onChange={(e) => onSetMdData('day1', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day2}
                    onChange={(e) => onSetMdData('day2', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day3}
                    onChange={(e) => onSetMdData('day3', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day4}
                    onChange={(e) => onSetMdData('day4', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day5}
                    onChange={(e) => onSetMdData('day5', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day6}
                    onChange={(e) => onSetMdData('day6', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <InputBox
                    prefixText={t('homepage.tuition.text1')}
                    suffixText={t('homepage.tuition.text2')}
                    value={mdData?.day7}
                    onChange={(e) => onSetMdData('day7', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <MonthInputBox
                    value1={mdData?.month1}
                    onChange1={(e) => onSetMdData('month1', e.target.value)}
                    value2={mdData?.month2}
                    onChange2={(e) => onSetMdData('month2', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={mdData?.month3}
                    onChange1={(e) => onSetMdData('month3', e.target.value)}
                    value2={mdData?.month4}
                    onChange2={(e) => onSetMdData('month4', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <MonthInputBox
                    value1={mdData?.month5}
                    onChange1={(e) => onSetMdData('month5', e.target.value)}
                    value2={mdData?.month6}
                    onChange2={(e) => onSetMdData('month6', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={mdData?.month7}
                    onChange1={(e) => onSetMdData('month7', e.target.value)}
                    value2={mdData?.month8}
                    onChange2={(e) => onSetMdData('month8', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <MonthInputBox
                    value1={mdData?.month9}
                    onChange1={(e) => onSetMdData('month9', e.target.value)}
                    value2={mdData?.month10}
                    onChange2={(e) => onSetMdData('month10', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <MonthInputBox
                    value1={mdData?.month11}
                    onChange1={(e) => onSetMdData('month11', e.target.value)}
                    value2={mdData?.month12}
                    onChange2={(e) => onSetMdData('month12', e.target.value)}
                    disabled={isMdDisabled}
                  />
                  <MonthInputBox
                    value1={mdData?.month13}
                    onChange1={(e) => onSetMdData('month13', e.target.value)}
                    value2={mdData?.month14}
                    onChange2={(e) => onSetMdData('month14', e.target.value)}
                    disabled={isMdDisabled}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('homepage.tuition.column5')}</th>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.amt1 || '')}
                    onChange={(e) =>
                      onSetMdData('amt1', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.amt2 || '')}
                    onChange={(e) =>
                      onSetMdData('amt2', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.amt3 || '')}
                    onChange={(e) =>
                      onSetMdData('amt3', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.amt4 || '')}
                    onChange={(e) =>
                      onSetMdData('amt4', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('homepage.tuition.column6')}</th>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.etc1 || '')}
                    onChange={(e) =>
                      onSetMdData('etc1', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.etc2 || '')}
                    onChange={(e) =>
                      onSetMdData('etc2', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.etc3 || '')}
                    onChange={(e) =>
                      onSetMdData('etc3', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
                <td>
                  <InputBox
                    prefixText=""
                    suffixText={t('homepage.tuition.text5')}
                    value={formatAmount(mdData?.etc4 || '')}
                    onChange={(e) =>
                      onSetMdData('etc4', formatAmount(e.target.value))
                    }
                    disabled={isMdDisabled}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="comm-bx__space">
          <div className="comm-btn__area right">
            {isMdDisabled ? (
              <Button
                className="btn-basic pink-line"
                onClick={() => setIsMdDisabled(false)}
                text={t('common.button.edit')}
                writeAuthYn={writeAuthYn}
              />
            ) : (
              <>
                <Button
                  className="btn-basic gray"
                  onClick={() => {
                    execute2(getTuition(currentCampus, isEduStepCode));
                    setIsMdDisabled(true);
                  }}
                  text={t('common.button.cancel')}
                />
                <Button
                  className="btn-basic pink"
                  onClick={() => onSubmit("MD")}
                  text={t('common.button.save')}
                  writeAuthYn={writeAuthYn}
                />
              </>
            )}
          </div>
        </div>
        {/*</>*/
      }
      </div>
    </Block>
    </>
  );
};

export default HomepageTuition;
